/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMediaUploadMutationRequest, AuditSpotAuditSpotMediaUploadMutationResponse } from "../models/AuditSpotAuditSpotMediaUpload";
import { buildFormData } from "../.kubb/config";

export function getAuditSpotAuditSpotMediaUploadUrl() {
  const res = { method: 'POST', url: `/audit-spot/v1/media` as const }
  return res
}

/**
 * @description Uploads audio or video media for spot recognition. Provide either a multipart file (`file` / `audio`) or a remote `sourceUrl` / `source_url`. Request body may be `multipart/form-data` or `application/json` (JSON requires `sourceUrl`).
 * @summary Upload media
 * {@link /audit-spot/v1/media}
 */
export async function auditSpotAuditSpotMediaUpload(data: AuditSpotAuditSpotMediaUploadMutationRequest, config: Partial<RequestConfig<AuditSpotAuditSpotMediaUploadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<AuditSpotAuditSpotMediaUploadMutationResponse, ResponseErrorConfig<Error>, AuditSpotAuditSpotMediaUploadMutationRequest>({ method : "POST", url : getAuditSpotAuditSpotMediaUploadUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}